import { usePathname } from "@lib/i18n/navigation-app-router";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";
import StoryblokImage from "@components/core/Storyblok/StoryblokImage";
import classNames from "classnames";

function BrandLink({ className, title, brandLink, src, alt, trackingName }) {
  const pathname = usePathname();
  const user = useCurrentUser();
  const userGroup = user?.user_group || "visitor";

  function sendTrackerData() {
    const defaultEventData = {
      tracking_name: trackingName,
      page: pathname,
      brand_link: brandLink,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  return (
    <div className={classNames("d-flex flex-column align-items-center gap-2", className)}>
      <div className="brand-image rounded-lg">
        <Link
          href={brandLink}
          prefetch={false}
          onClick={() => sendTrackerData()}
          className="w-100"
        >
          <StoryblokImage
            className="w-100 h-100 rounded-lg"
            alt={alt}
            src={src}
            sizes="(min-width: 992px) 50vw, 100vw"
          />
        </Link>
      </div>
      <h6 className={classNames("brand-title", !title && "title-missing")}>{title || "title"}</h6>
    </div>
  );
}

export default BrandLink;
